import type { Status } from '@/types'
import { get, post } from '@/util/auth'

import { API_PATH_EMPLOYEE_CONSENT, API_PATH_STATUS } from './apiRoutes'

const statusResources = {
  get: async () => get<Status>(API_PATH_STATUS),
  // mutations
  giveConsent: (consentId: number) =>
    post(API_PATH_EMPLOYEE_CONSENT.replace(':consentId', String(consentId))),
}

export default statusResources
